<!--
|---------------------------------------------
| Navbar Component 
|---------------------------------------------
| @usage Import the component and use, no params
| Main Navbar component
-->

<template>
  <div class="appnavbar-container">
    <div
      @click="closeMiniDropdown()"
      class="overlay-invisible"
      :class="{ 'overlay-visible': isActiveMiniDropdown }"
    ></div>
    
    <Teleport to="body">
    <!-- MODAL CENTRAL DO 'PERFIL' -->
    <ModalCentral
      componentName="Profile"
      title="Perfil"
      idName="Profile"
    />
    </Teleport>

    <!-- MODAL CENTRAL DO 'PERFIL' -->
    <ModalCentral
      componentName="UserInvites"
      title="Convites Recebidos"
      idName="UserInvites"
    />

    <section class="acessibility-section">
      <div class="container d-flex justify-content-end acessibility-menu">
        <span class="d-flex align-items-center high-contrast mr-2">Fonte:</span>
        <div @click="defaultFont()" class="d-flex align-items-center high-contrast mr-2">
          <div>
            <span class="font-weight-bold">A</span>
          </div>
        </div>
        <div @click="increaseFont()" class="d-flex align-items-center high-contrast mr-2">
          <div>
            <span class="font-weight-bold">A+</span>
          </div>
        </div>
        <div @click="decreaseFont()" class="d-flex align-items-center high-contrast mr-3">
          <div>
            <span class="font-weight-bold">A-</span>
          </div>
        </div>
        <div @click="highContrast()" class="d-flex align-items-center high-contrast">
          <i class="fas fa-adjust mr-1" ></i>
          <div>
            <span class="hidden-class">Alto contraste</span>
          </div>
        </div>
      </div>
    </section>

    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container container-navbar">
        <router-link to="/"
          ><img id="logo" class="mr-xl-4 mr-lg-2" src="../../assets/img/App/Navbar/logo-navbar.png"
        /></router-link>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">

            <li class="nav-item">
              <a
                class="nav-link d-lg-none d-xl-block"
                href="/"
                target="_self"
              >
                Página Inicial</a
              >
              <a
                class="nav-link d-none d-lg-block d-xl-none"
                href="/"
                target="_self"
              >
                Início</a
              >
            </li>

            <li v-if="isLogged" :class="'nav-item d-block'">
              <a
                class="nav-link"
                href="/panoramaSAPI/INAPI"
                target="_self">Panorama SAPI</a>
            </li>

            <li v-else :class="'d-none'">
              <a
                class="nav-link"
                href="/panoramaSAPI/INAPI"
                target="_self">Panorama SAPI</a>
            </li>
            
            <li class="nav-item">
              <a
                class="nav-link d-lg-none d-xl-block"
                href="/materiaisedocumentos/materiais"
                target="_self"
              >
                Materiais e Documentos
              </a>
              <a
                class="nav-link d-none d-lg-block d-xl-none"
                href="/materiaisedocumentos/materiais"
                target="_self"
              >
                Materiais
              </a>
            </li>

             <li class="nav-item">
              <a
                class="nav-link"
                href="/sobre"
                target="_self"
              >
                Sobre</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="/politica.html"
                target="_self"
              >
                Politica</a
              >
            </li>
          </ul>

          <div v-if="isLogged" :class="' bt-width mr-4'">
            <a
              href="/dados/paineladministrativo"
              target="_self"
            >
              <button class="button-logged-dados button-dados">
                Dados
              </button>
            </a>
          </div>

          <div class="div-logged" v-if="isLogged">
            <!-- <div class="notification-wrapper">
              <div class="notification-icon">
                <i class="fa fa-bell icon-login"></i>
              </div>
              <div class="red-circle"></div>
            </div> -->
            <i
              @click="showMiniDropdown()"
              class="logged-user-icon fa fa-user-circle icon-login ml-2"
            ></i>
            <span class="user-name" @click="showMiniDropdown()"
              >Olá,<span>{{ " " + getUserInfo }}</span></span
            >

            

            <div
              class="dropdown-box"
              :class="{ 'dropdown-box-visible': isActiveMiniDropdown }"
            >
              <div class="mini-dropdown">
                <!-- TRIÂNGULO DO POP-UP PEQUENO -->
                <!-- <div class="mini-triangle">
                  <svg
                    class="triangulo-1"
                    width="26"
                    height="30"
                    viewBox="0 0 36 33"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.6699 2.5C15.5944 -0.833332 20.4056 -0.833334 22.3301 2.5L35.3205 25C37.245 28.3333 34.8394 32.5 30.9904 32.5H5.00962C1.16062 32.5 -1.24501 28.3333 0.679492 25L13.6699 2.5Z"
                      fill="white"
                    />
                  </svg>
                </div> -->

                <!-- POP-UP PEQUENO -->
                <div class="mini-pop-up shadow-lg pt-3 pr-3 pb-3 pl-4">
                  <div
                    @click="loadProfile()"
                    class="
                      row-md-12
                      font-weight-light
                      pl-0
                      pr-0
                      item-minidropdown
                    "
                    data-target="#Profile"
                    data-toggle="modal"
                  >
                    <i class="fas fa-address-card mr-1"></i>Perfil
                  </div>
                  
                  <div
                    @click="logout()"
                    class="
                      row-md-12
                      font-weight-light
                      pl-0
                      pr-0
                      item-minidropdown
                    "
                  >
                    <i class="fas fa-sign-out-alt mr-1"></i>Sair
                  </div>
                </div>
              </div>
            </div>
          </div>

           <router-link to="/login" v-else class="entrar" id="acesse">
          
            <!-- <p @click="openLogin" id="acesse">Entrar</p> -->
           
              <button class="login-register-buttons">Entrar</button>
          
           </router-link>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
// import Button from "../Button";
// import DropdownMenu from "../DropdownMenu";
// import ModalLateral from "../ModalLateral";
import ModalCentral from "../ModalCentral";
import Swal from "sweetalert2";
import { Notyf } from "notyf";
const notyf = new Notyf({
  duration: 5000,
  position: {
    x: "left",
    y: "bottom",
  },
  types: [
    {
      type: "info",
      background: "#18a0fb",
      icon: {
        className: "fa fa-info-circle",
        tagName: "i",
        color: "white",
      },
    },
  ],
});

export default {
  name: "Navbar",
  data() {
    return {
      isActiveMiniDropdown: false,
      high: this.$store.getters.getHighContrast,
      fsizeBody: 16,
    };
  },
  components: {
    // Button,
    // DropdownMenu,
    // ModalLateral,
    ModalCentral
  },
  computed: {
    isLogged() {
      return this.$store.getters.getIsLogged;
    },
    getUserInfo() {
      if (this.$store.getters.getUserInfo) {
        return this.$store.getters.getUserInfo.data.nome.split(" ")[0];
      } else {
        return "Visitante";
      }
    },
  },
  methods: {
    changeNavPadding() {
      this.$emit('changeNavbar');
    },
    changeDefDec() {
      this.$emit('changeNavbarDefDec');
    },
    loadProfile() {
      this.emitter.emit('loadDataProfile');
    },
    openLogin() {
      this.$refs.ModalLogin.showModalLateral();
    },
    closeLogin() {
      this.$refs.ModalLogin.closeModalLateral();
    },
    showDropdownMenuBoasPraticas() {
      this.$refs.DropdownMenuBoasPraticas.getScreenSizeforOverlay();
      this.$refs.DropdownMenuBoasPraticas.showDropdownMenu();
    },
    showDropdownMenuMateriais() {
      this.$refs.DropdownMenuMateriais.getScreenSizeforOverlay();
      this.$refs.DropdownMenuMateriais.showDropdownMenu();
    },
    showDropdownMenuDados() {
      this.$refs.DropdownMenuDados.getScreenSizeforOverlay();
      this.$refs.DropdownMenuDados.showDropdownMenu();
    },
    showMiniDropdown: function () {
      this.isActiveMiniDropdown = true;
    },
    closeMiniDropdown: function () {
      this.isActiveMiniDropdown = false;
    },
    logout() {
      Swal.fire({
        title: "Tem certeza que deseja sair?",
        text: "Ao sair, todos os dados não salvos serão perdidos.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim, tenho certeza",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$cookies
            .keys()
            .forEach((cookie) => this.$cookies.remove(cookie));
          this.$store.commit("setIsLogged", false);
          this.$store.commit("setUserInfo", null);
          this.$store.commit('setExpireCookieDate', null)
          this.$store.commit('setIsAlreadyShowedExpNotyf', false)
          this.$router.push("/");
          notyf.open({
            type: "info",
            message: "Você efetuou logoff.",
          });
        }
      });
      this.closeMiniDropdown();
    },
    highContrast(){
      if(this.high == null){
        this.high = "high-contrast";
      }
      else this.high = null;
      this.$store.commit("setHigh", this.high);
    },

    increaseFont(){
      if(this.fsizeBody < 25){
        this.fsizeBody+=1;
        const htmlFont = document.querySelector('html');
        htmlFont.style.fontSize = this.fsizeBody+"px";
        this.changeNavPadding();
      }
      else{
        notyf.open({
          type: "info",
          message: "O texto já está no tamanho máximo.",
        });
      }
    },

    decreaseFont(){
      if(this.fsizeBody > 9){
        this.fsizeBody-=1;
        const htmlFont = document.querySelector('html');
        htmlFont.style.fontSize = this.fsizeBody+"px";
        this.changeDefDec();
      }
      else{
        notyf.open({
          type: "info",
          message: "O texto já está no tamanho mínimo.",
        });
      }
    },

    defaultFont(){
      this.fsizeBody = 16;
      const htmlFont = document.querySelector('html');
      htmlFont.style.fontSize = this.fsizeBody+"px";
      this.changeDefDec();
    }
  },
};
</script>

<style scoped>
.appnavbar-container{
  position: fixed;
  width: 100%;
  z-index: 100;
}
/*
 |-----------------------------------------------------
 |--ESTILIZANDO A PRÓPRIA NAVBAR (TAMANHO HORIZONTAL,
 |--ITENS DO MENU, ETC)
 |-----------------------------------------------------
 */
.navbar {
  background-image: linear-gradient(to right, #1E4F37 , #00853B);
  -webkit-box-shadow: 0px 10px 38px -12px rgba(96, 133, 236, 0.425);
  -moz-box-shadow: 0px 10px 38px -12px rgba(96, 133, 236, 0.425);
  box-shadow: 0px 10px 38px -12px rgba(96, 133, 236, 0.425);
  padding: 1rem;
  /*padding: 0.5rem 2rem; //! TODO: RESPONSIVIZAR ISSO (TELAS MAIORES -> PADDING MAIOR)*/
}
.container-navbar{
  max-width: 95% !important;
}
#logo {
  max-height: 3.8rem;
  /* width: auto;
    cursor: pointer; */
}

#logo2 {
  max-height: 3.8rem;
  width: auto;
  cursor: pointer;
}

ul {
  font-size: 1.063rem;
  color: #766565;
  font-weight: lighter;
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
}

ul li {
  margin: 0.5rem 0 0;
  cursor: pointer;
}

#ou {
  font-size: 1rem;
  font-weight: bold;
  color: #635a5a;
  text-transform: uppercase;
  margin-bottom: 0;
  cursor: default;
}

#acesse {
  width: 10%;
}

.acesse{
  pointer-events: none;
}

.login-register-buttons {
  background: #fc6839;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
  border: none;
  font-size: 1rem;
  font-weight: bold;
  color: #ffffff;
  cursor: pointer;
  margin: 0;
  transition: all ease-in-out 0.26s;
  pointer-events: none;
}

.arrow {
  display: inline-block;
  border-top: 6px solid #766565;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  margin-left: 5px;
  vertical-align: middle;
}

.nav-item {
  text-align: center;
}

.dropdown-menu {
  margin: 0rem 0rem 0.8rem 0rem;
  border: none;
  padding: 0.05rem;
  background-color: #e0e0e0;
}

.dropdown-menu .dropdown-item {
  background-color: #f8f7f7;
  padding: 0.4rem;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  text-transform: none;
  text-align: center;
}

.dropdown-menu .dropdown-item:hover {
  background-color: #e0e0e0;
  color: rgba(0, 0, 0, 0.7);
}

.navbar-light .navbar-nav .nav-link {
  transition: all ease-in-out 0.2s;
  color: #ffffff;
}

.div-logged {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.icon-login {
  color: #fff;
  cursor: pointer;
  font-size: 1.2rem;
}

.notification-wrapper:hover > .notification-icon .icon-login  {
  animation: bellAnimation 0.8s ease-in-out;
  transform-origin: center;
}

@keyframes bellAnimation {
  0% {
    transform: rotateZ(0deg);
  }
  25% {
    transform: rotateZ(25deg);
  }
  75% {
    transform: rotateZ(-25deg);
  }
  100% {
    transform: rotateZ(0deg);
  }
}

/* Inicio do CSS do botão de dados */
.button-dados{
  border: none;
  cursor: pointer;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
}

.button-dados:focus{
  outline: none;
}

.bt-width{
  width: 10%;
}

.button-notlogged-dados{
  background: #bfbfbf;
  color: rgba(255, 251, 251, 0.45);
  font-weight: bold;
  margin:0;
  cursor: default;
}

.button-logged-dados{
  background-color: #fc6839;
  color: white;
  margin:0;
  font-weight: bold;
}

/* Fim do CSS do Botão de dados */

.user-name {
  margin-left: 0.5rem;
  text-transform: none;
  font-size: 1.1rem;
  font-size: 1rem;
  color: #fff;
  cursor: default;
  user-select: none;
}

.user-name span {
  text-transform: capitalize;
  cursor: default;
  user-select: none;
}

.user-name:hover, .user-name span:hover{
  cursor: pointer;
}

.notification-wrapper {
  position: relative;
  width: 2rem;
  height: 2rem;
  background: white;
  border-radius: 100%;
  padding: 0.3rem;
  box-shadow: 1px 2px 6px -3px rgb(0 0 0 / 25%);
  cursor: pointer;
}

.red-circle {
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgb(235, 67, 67);
  height: 0.55rem;
  width: 0.55rem;
  border-radius: 50%;
}

.notification-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-45%, -45%);
}

.logged-user-icon{
  font-size: 1.5rem;
  transition: all 0.3s ease;
}

.logged-user-icon:hover {
  color: #4b4646;
}

.overlay-invisible {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(22, 22, 22, 0);
  z-index: 2;
  transition: all ease-in-out 0.3s;
  opacity: 0;
  pointer-events: none;
}

.overlay-visible {
  opacity: 1;
  pointer-events: all;
  cursor: default;
}

.mini-triangle {
  margin: 0rem;
  display: center;
  align-items: center;
  justify-items: center;
  position: absolute;
  top: -16%;
  left: 67%;
}
.dropdown-box {
  position: absolute;
  top: 146%;
  right: -4%;
  z-index: 2;
  opacity: 0;
  pointer-events: none;
  cursor: default;
  transition: all 0.4s ease;
}

.dropdown-box-visible {
  opacity: 1;
  cursor: pointer;
  pointer-events: all;
}

.mini-dropdown {
  position: relative;
}

.mini-pop-up {
  height: 5.8rem;
  width: 7rem;
  background-color: white;
  color: grey;
  border-radius: 1rem;
  transition: color ease-in-out 0.2s;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.item-minidropdown:hover {
  color: rgb(58, 58, 58);
}

/*-----------------------------------------------------*/

/*
 |-----------------------------------------------------
 |--ADICIONANDO PSEUDO-CLASSE :FOCUS PARA EXIBIR DROPDOWN
 |-----------------------------------------------------
 */
#acesse:hover {
  color: #1a85cc;
}
/*-----------------------------------------------------*/

/*
 |-----------------------------------------------------
 |--ADICIONANDO @MEDIA QUERIES
 |-----------------------------------------------------
*/
@media screen and (max-width: 991px) {
  #ou {
    margin: 0.4rem 0rem;
  }
}

@media screen and (min-width: 992px) {
  .dropdown-menu {
    display: none;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav {
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
}

/* @mMEDIA PARA RESPONSIVIDADE DO NAVBAR */
@media screen and (max-width: 991px) {
  .navbar-collapse{
    width: 100%;
  }
  
  .nav-item {
    text-align: left;
    width: 100%;
  }

  .navbar-collapse ul {
    align-items: flex-start;
  }

  .div-logged {
    margin-top: 1rem;
  }

  .navbar-box-mobile {
    display: grid;
    grid-template-columns: 4rem 1fr;
    gap: 1rem;
  }

  .box-mobile-text{
    justify-self: flex-start;
  }

  .box-mobile-img {
    align-self: center;
    max-width: 100%;
  }

  .box-mobile-img img{
    max-width: 3rem;
  }

  box-mobile-text {
    text-align: left;
  }

  .secao-titulo-dropdown {
    font-size: 1rem;
    font-weight: 800;
    color: #655d5d;
    text-align: left;
    margin: 0;
  }

  .secao-texto-dropdown {
    font-size: 0.9rem;
    color: #655d5d;
    margin: 0;
    white-space: initial;
    text-align: left;
  }

  .bt-width{
    width: 100%;
  }

  .div-logged{
    justify-content: flex-start;
  }
  
  .navbar-collapse{
    padding-top: 0.75rem;
    padding-bottom: 1.5rem;
  }
}

.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.active,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .show > .nav-link {
  color: rgb(0 0 0 / 60%);
}

.sair-button {
  padding: 0.2rem 1.2rem;
  margin-left: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 5px;
  background-color: white;
  border: 0.1rem solid #0d9f9f;
  color: #0d9f9f;
  cursor: pointer;
  outline: none;
  transition: all ease-in-out 0.3s;
}

.sair-button:hover {
  background-color: #0d9f9f;
  color: white;
}

/*-----------------------------------------------------*/

.acessibility-section{
  background-color: #FEB979;
  padding: 0.25rem 1rem;
}

.acessibility-menu{
  max-width: 95% !important;
}

.high-contrast{
  cursor: pointer;
  color: white;
  font-size: 0.938rem;
}

@media screen and (max-width:576px) {
  .hidden-class{
    display: none;
  }
}
</style>
